<template>
  <el-container class="man_page">
      <RouterView />
  </el-container>
</template>
<script setup lang="ts">
window.onload = function () {
  const new_w_width = window.outerWidth;
  if (new_w_width > 750) {
    document.getElementsByTagName("html")[0].style.fontSize = "16px";
    return;
  }
  const h_size = new_w_width / 750 * 16;
  document.getElementsByTagName("html")[0].style.fontSize = h_size + "px";
}
window.onresize = function () {
  const new_w_width = window.outerWidth;
  if (new_w_width > 750) {
    document.getElementsByTagName("html")[0].style.fontSize = "16px";
    return;
  }
  const h_size = new_w_width / 750 * 16;
  document.getElementsByTagName("html")[0].style.fontSize = h_size + "px";
}
</script>
<style scoped></style>
